/* unplugin-vue-components disabled */import { render } from "./RightBorrow.vue?vue&type=template&id=d3400434"
import script from "./RightBorrow.vue?vue&type=script&lang=js"
export * from "./RightBorrow.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__